export var defaultPageSizes = [5, 10];
export var defaultTableVariant = "embedded";
export var defaultDropZoneHeight = 500;
export var maxDirectoryTraversalDepth = 6;
export var defaultAllowedActions = {
    download: true,
    upload: true,
    rename: true,
    createFolder: true,
    delete: true,
};
